var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMnp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 58,
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 57,
    rx: 3.5,
    fill: "white",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.685 20.3019L13.685 20.3019C14.3748 20.2901 16.0605 20.2614 16.795 22.7433C17.3149 24.5001 18.1431 27.3779 19.2796 31.3766H19.7424C20.9612 27.1609 21.7985 24.2831 22.2542 22.7433C22.9874 20.2657 24.7546 20.29 25.6116 20.3018C25.6661 20.3026 25.717 20.3033 25.7636 20.3033L31.7806 20.3033V39.0427H25.6479V27.9992H25.2367L21.818 39.0427H17.204L13.7853 27.9911H13.3741V39.0427H7.24139V20.3033L13.5878 20.3032C13.6175 20.303 13.65 20.3025 13.685 20.3019ZM40.5871 20.3033V31.355H41.0764L45.2349 22.2672C46.0421 20.4587 47.7626 20.3033 47.7626 20.3033H53.6972V39.0427H47.4364V27.9911H46.9472L42.8702 37.0788C42.063 38.8791 40.261 39.0427 40.261 39.0427H34.3264V20.3033H40.5871ZM68.6847 33.4606C71.7211 33.4606 74.4637 31.6861 75.337 29.2084H56.1655V39.0428H62.1191V33.4606H68.6847Z",
    fill: "#40A548"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.972 20.3033H55.8534C56.1656 24.4753 59.7542 28.0468 63.4691 28.0468H75.7507C76.4595 24.5794 74.0196 20.3033 68.972 20.3033Z",
    fill: "#1291D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnp);
export default __webpack_public_path__ + "static/media/MNP.3012d93cc3931adcb216758a97794957.svg";
export { ForwardRef as ReactComponent };